import React from 'react'
import { DateSeparator, DateJumpPill } from 'components/DateSeparator'
import type { TJumpTarget } from 'components/DateSeparator'

export type { TJumpTarget }

export interface Props {
	/** e.g. "Monday, August 3rd" */
	label: string
	onJump: (target: TJumpTarget) => void
	className?: string
}

/**
 * The day separator in a room conversation: a hairline rule with a centred
 * pill sitting on it, and a menu on the pill for moving around the history.
 *
 * Both halves now live in components/DateSeparator, shared with the admin
 * image library, which shows the same separator over its day-grouped grid.
 *
 * `sticky` is what makes the current day's pill float at the top as you
 * scroll, the way Slack's does, without a scroll listener tracking which day is
 * in view.
 */
const DateDivider = ({ label, onJump, className = '' }: Props) => (
	<DateSeparator sticky className={className}>
		<DateJumpPill label={label} onJump={onJump} noun="conversation" />
	</DateSeparator>
)

export default DateDivider
